<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="1100"
          :show-more-scheme="true"
          :show-simple="false"
          :expand-adv="true"
          :search-item-code="$t('Insurance.PolicyManagement')"
          :custom-sim-query-placeholder="$t('Insurance.QuickSearchPolicyNumber')"
          @advSearchItemCallBack="fetchData"
        >
          <template slot="operations">
            <el-button type="primary" @click="viewPolicy">{{ $t('CargoMsg.Cargo_View') }}</el-button>
          </template>
          <template v-slot:searchAreaHeader />
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="1100000"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <div style="display: flex;justify-content: flex-end;">
            <span v-if="searchConditions.total > 0" style="color: orange;font-size: 20px;">{{ $t('Insurance.TotalPremium') }}</span>
            <span v-if="searchConditions.total > 0" style="color: red;font-size: 20px;">{{ totalPremium }}</span>
          </div>
          <cargo-pagination
            config-module="190904"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
    <!--注销弹窗-->
    <el-dialog
      v-el-drag-dialog
      :title="$t('Insurance.Cancellation')"
      width="500px"
      :visible.sync="cancellationOfPolicyDialog.visible"
      style="height:400px;"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="50px" label-position="left">
          <el-form-item>
            <span style="color: red">{{ $t('Insurance.PleaseInTheCancellationReason') }}</span>
          </el-form-item>
          <el-form-item label-width="" style="margin-left: 50px;">
            <el-input v-model="cancellationOfPolicyDialog.reasons" type="textarea" :rows="6" style="width: 300px;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" style="padding:10px;">
        <el-button type="primary" @click="confirmCancellationOfPolicy">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="cancellationOfPolicyDialog.visible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import OperationRender from '@/components/OperationRender/index'
import ColumnUtils from '@/utils/ColumnUtils'
import { getQueryConfig, getDeteleInsure, getCancelInsureConfig, getUpdateInsureConfig } from '@/api/external/insure'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import { Once } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { getCargoJumpUrl } from '@/utils/permission'
import Store from '@/store'

export default {
  name: 'PolicyManagement',
  components: { searchItem },
  data() {
    return {
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowDoubleClicked: this.rowDoubleClick
      },
      gridParams: {},
      filterJson: {},
      gridApi: null,
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        snapshotConditions: [] // 存储高级查询条件（点击查询时赋值）
      },
      totalPremium: '',
      once: new Once(this),
      cancellationOfPolicyDialog: {
        visible: false,
        reasons: '', // 注销理由
        uuid: null // 保单UUID
      },
      documentManage: new DocumentManage()
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Insurance.InsureNo'), field: 'insureNo', colId: 'insureNo', width: 200,
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('linkToPolicyDetails')
            return `<a onclick="${methodPath}('${params.data.uuid}','${params.data.officeId}')" style="color:blue">` + params.value + '</a>'
          }
        },
        { headerName: this.$t('Insurance.PolicyNo'), field: 'policyNo', colId: 'policyNo', width: 200 },
        { headerName: this.$t('Insurance.InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo', width: 200 },
        { headerName: this.$t('Insurance.TheInsured'), field: 'insuredName', colId: 'insuredName', width: 200 },
        { headerName: this.$t('Insurance.DateOfShipment'), field: 'inceptionDate', colId: 'inceptionDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.PlaceOfOrigin'), field: 'fromHaulway', colId: 'fromHaulway', width: 200 },
        { headerName: this.$t('Insurance.Destination'), field: 'toHaulway', colId: 'toHaulway', width: 200 },
        { headerName: this.$t('Insurance.BillOfLoadingNo'), field: 'blNo', colId: 'blNo', width: 200 },
        { headerName: this.$t('Insurance.Premium'), field: 'premium', colId: 'premium', width: 200 },
        { headerName: this.$t('Insurance.SubmissionTime'), field: 'orderCommitDate', colId: 'orderCommitDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryTime'), field: 'orderGenerateDate', colId: 'orderGenerateDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryStatus'), field: 'orderStatus', colId: 'orderStatus', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.orderStatusLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.Operation'), field: '', colId: '', width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Insurance.EditPolicy'),
                type: 'primary',
                onClick: (params) => {
                  this.editPolicy(params)
                },
                visible: (params) => params.orderStatus === '0'
              },
              {
                title: this.$t('Insurance.DeletePolicy'),
                type: 'danger',
                onClick: (params) => {
                  this.deletePolicy(params)
                },
                visible: (params) => params.orderStatus === '0'
              },
              {
                title: this.$t('Insurance.DownloadPolicy'),
                type: 'primary',
                onClick: (params) => {
                  this.downloadPolicy(params)
                },
                visible: (params) => params.orderStatus === '1' || params.orderStatus === '3'
              },
              {
                title: this.$t('Insurance.CancellationOfPolicy'),
                type: 'danger',
                onClick: (params) => {
                  this.cancellationOfPolicy(params)
                },
                visible: (params) => params.orderStatus === '1' || params.orderStatus === '3'
              },
              {
                title: this.$t('Insurance.ReIssuePolicy'),
                type: 'primary',
                onClick: (params) => {
                  this.reIssuePolicy(params)
                },
                visible: (params) => params.orderStatus === '2' || params.orderStatus === '4'
              }
            ]
          }
        }
      ]
    }
  },
  watch: {
  },
  beforeRouteEnter(to, from, next) {
    cache.load(cacheName.CONFIG).then(() => {
      if (cache.config.get('isPlatformInsurance') === '1') {
        next()
      } else {
        console.log('InsurancePolicy')
        const url = getCargoJumpUrl({
          code: 'InsurancePolicy',
          language: Store.getters.language,
          sessionId: Store.getters.token,
          branchId: Store.getters.currentOfficeId,
          departmentId: Store.getters.currentDeptId
        })
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = url
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
        next(false)
      }
    })
  },
  mounted() {
    const params = this.$route.query
    if (params) {
      if (params.hasOwnProperty('policyNo')) {
        const policyNo = params.policyNo
        if (policyNo) {
          this.filterJson = {}
          this.filterJson.policyNo = policyNo
          this.filterJson.pageNum = 1
          this.filterJson.pageSize = 100
          this.filterJson.branchId = this.$store.getters.currentOfficeId
          this.loading = getLoading()
          getQueryConfig(this.filterJson).then(res => {
            this.rowData = res.data.list
            this.searchConditions.pageNum = res.data.pageNum
            this.searchConditions.pageSize = res.data.pageSize
            this.searchConditions.total = Number(res.data.total)
            this.getTotalPremium()
          }).finally(() => {
            this.loading.close()
          })
        }
      } else {
        this.toAdvQueryList()
      }
    }
  },
  async created() {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('linkToPolicyDetails', function(value, officeId) {
      context.linkToPolicyDetails(value, officeId)
    })
  },
  beforeDestroy() {
  },
  methods: {
    // 列表查询
    fetchData(conditions) {
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    // 点击分页，进行分页查询
    fetchDataByPage() {
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    toAdvQueryList(data) {
      this.filterJson = {}
      this.filterJson.conditions = []
      console.log('data-------------------------------------', data)
      if (typeof data !== 'undefined') {
        // todo 判断查询条件中是否有启运地或者目的地， 根据fieldName
        // todo 如果同时选个海港和空港启运地或者目的地（操作符号相同时），根据fieldName把选中的数据合并掉
        for (const item of data) {
          if (item.fieldType === 'FIELD_AIRPORT' || item.fieldType === 'FIELD_SEAPORT') {
            item.fieldName = item.fieldName.substr(0, item.fieldName.length - 2)
          }
        }
        this.searchConditions.snapshotConditions = data
        this.filterJson.conditions = data
      }
      this.filterJson.pageNum = this.searchConditions.pageNum
      this.filterJson.pageSize = this.searchConditions.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      getQueryConfig(this.filterJson).then(res => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.getTotalPremium()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 列表双击查看详情
    rowDoubleClick() {
    },
    // 查看保单
    viewPolicy(data = null) {
    },
    // 编辑保单
    editPolicy(policy) {
      if (!this.$checkPermission(['button_insurance_editInsure']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToEditPolicy'))
        return
      }
      this.$router.push({ name: 'PolicyDetail', query: { 'key': policy.uuid, 'active': 0, 'officeId': policy.officeId }})
    },
    // 删除保单
    deletePolicy(policy) {
      if (!this.$checkPermission(['button_insurance_deleteInsure']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToDeletePolicy'))
        return
      }
      this.$confirm(this.$t('Insurance.DeletingThePolicyRecordContinue'), this.$t('Insurance.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        getDeteleInsure(policy).then(res => {
          this.$message.warning(this.$t('Insurance.InsurancePolicyNumber') + policy.insureNo + this.$t('Insurance.Deleted'))
          this.toAdvQueryList()
        })
      }).catch()
    },
    // 下载保单
    downloadPolicy(policy) {
      const downLoadURL = 'https://ceshi.tokiomarine.com.cn:7111/CIOD_ESB/httpservices/ebussiness/policypdfdownload?businessNo=' + policy.policyNo + '&from=CARGOWARE'
      const el = document.createElement('a')
      document.body.appendChild(el)
      el.href = downLoadURL
      el.target = '_blank'
      el.click()
      document.body.removeChild(el)
      getUpdateInsureConfig(policy.uuid).then(res => {
        this.toAdvQueryList()
      })
    },
    // 注销保单
    cancellationOfPolicy(policy) {
      if (!this.$checkPermission(['button_insurance_cancelInsure']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToCancelPolicy'))
        return
      }
      this.cancellationOfPolicyDialog.uuid = policy.uuid
      this.cancellationOfPolicyDialog.policyNo = policy.policyNo
      this.cancellationOfPolicyDialog.visible = true
    },
    // 确认注销保单回调函数
    confirmCancellationOfPolicy() {
      if (!this.cancellationOfPolicyDialog.reasons) {
        this.$message.warning('请填写注销原因')
        return
      }
      getCancelInsureConfig({ 'insureUuid': this.cancellationOfPolicyDialog.uuid, 'reasons': this.cancellationOfPolicyDialog.reasons }).then(res => {
        this.cancellationOfPolicyDialog.visible = false
        this.cancellationOfPolicyDialog.reasons = ''
        if (res.data === '1') {
          this.$message.warning(this.$t('Insurance.PolicyNumber2') + this.cancellationOfPolicyDialog.policyNo + this.$t('Insurance.Canceled'))
          this.toAdvQueryList()
        } else {
          this.$message.warning(res.data)
        }
      })
    },
    // 重出保单
    reIssuePolicy(policy) {
      if (!this.$checkPermission(['button_insurance_reInsure']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToReissuePolicy'))
        return
      }
      if (policy.orderStatus === '4') {
        this.$message.warning(this.$t('Insurance.YouBeforeAndCannotAgain'))
        return
      }
      // this.editPolicy(policy)
      this.$router.push({ name: 'PolicyDetail', query: { 'key': policy.uuid, 'active': 0, 'isReIssue': '1', 'officeId': policy.officeId }})
    },
    // 列表选中刷新
    toRefreshSelectedCount() {
      this.once.excute(this.getTotalPremium, [], 200)
    },
    // 计算总保费
    getTotalPremium() {
      let total = 0
      let rowData = []
      const selections = getGridSelected(this.gridOptions)
      if (selections && selections.length > 0) {
        rowData = selections
      } else {
        rowData = this.rowData
      }
      // 计算逻辑
      const map = new Map()
      if (rowData && rowData.length > 0) {
        for (const item of this.rowData) {
          const currency = item.currency // 币种
          if (item.calcPremium === '' || item.calcPremium === null) {
            continue
          }
          const insuranceAmount = isNaN(item.calcPremium) ? 0 : item.calcPremium // 币种对应的总保费
          if (!map.has(currency)) {
            map.set(currency, 0)
          }
          let total = map.get(currency)
          total += parseFloat(insuranceAmount)
          map.set(currency, total)
        }
      }
      map.forEach(function(value, key) {
        total += key + ':' + NumberUtils.roundHalfUp(value, 2) + ';'
      })
      if (total) {
        this.totalPremium = total.substr(1, total.length)
      }
    },
    linkToPolicyDetails(uuid, officeId) {
      const active = 2
      this.$router.push({ name: 'PolicyDetail', query: { 'key': uuid, 'active': active, 'viewSource': 'manage', 'officeId': officeId }})
    }
  }
}
</script>

<style lang="scss">
</style>

